import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CardErrorState, CardSliceState } from "../../../types/paymentType";

const initialState: {
  cardData: CardSliceState;
  cardErrors: CardErrorState;
} = {
  cardData: {
    txn_mode: "DC",
    card_number: "",
    card_holder_name: "",
    card_cvv: "",
    card_expiry_date: "",
  },
  cardErrors: {},
};

const cardSlice = createSlice({
  name: "card",
  initialState,
  reducers: {
    setCardData: (state, action: PayloadAction<Partial<CardSliceState>>) => {
      state.cardData = { ...state.cardData, ...action.payload };
    },
    resetCardData: (state) => {
      state.cardData = {
        txn_mode: "DC",
        card_number: "",
        card_holder_name: "",
        card_cvv: "",
        card_expiry_date: "",
      };
    },
    setCardErrors: (state, action: PayloadAction<Partial<CardErrorState>>) => {
      state.cardErrors = { ...state.cardErrors, ...action.payload };
    },
    resetCardErrors: (state) => {
      state.cardErrors = {};
    },
  },
});

export const { setCardData, resetCardData, setCardErrors, resetCardErrors } =
  cardSlice.actions;

export default cardSlice.reducer;
